import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { cn } from './cn';

type Props = { to: string; children: ReactNode; tone?: 'brand' | 'light'; className?: string };

/** Lien d'appel à l'action: un trait qui s'allonge et une flèche qui avance au survol. */
export default function CtaLink({ to, children, tone = 'brand', className }: Props) {
  const light = tone === 'light';
  return (
    <Link
      to={to}
      className={cn(
        'group inline-flex items-center gap-3 py-1 text-[0.875rem] font-semibold uppercase tracking-[0.094rem] transition-colors duration-[250ms] ease-in-out',
        light ? 'text-white hover:text-muted' : 'text-charcoal hover:text-brand-dark',
        className,
      )}
    >
      <span>{children}</span>
      <span aria-hidden className="flex items-center">
        <span className={cn('h-px w-6 transition-all duration-300 ease-out group-hover:w-14', light ? 'bg-brand' : 'bg-brand')} />
        <svg viewBox="0 0 8 12" className="-ml-px h-3 w-2 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M1 1l5 5-5 5" />
        </svg>
      </span>
    </Link>
  );
}
